import { render } from "./LanguageSwitcherComponent.vue?vue&type=template&id=533d9dde&scoped=true"
import script from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js"

import "./LanguageSwitcherComponent.vue?vue&type=style&index=0&id=533d9dde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533d9dde"]])

export default __exports__